import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import IVFFertilityAnalytics from "./pages/services/IVFFertilityAnalytics";
import HealthcarePerformanceAnalytics from "./pages/services/HealthcarePerformanceAnalytics";
import ClinicalQualityComplianceAnalytics from "./pages/services/ClinicalQualityComplianceAnalytics";
import PredictiveAnalyticsDecisionIntelligence from "./pages/services/PredictiveAnalyticsDecisionIntelligence";
import ResearchBiostatistics from "./pages/services/ResearchBiostatistics";
import CaseStudies from "./pages/CaseStudies";
import CaseStudyDetail from "./pages/CaseStudyDetail";
import IVFDashboardCaseStudy from "./pages/IVFDashboardCaseStudy";
import PatientSatisfactionCaseStudy from "./pages/PatientSatisfactionCaseStudy";
import IVFCancellationRiskCaseStudy from "./pages/IVFCancellationRiskCaseStudy";
import OncologySurvivalCaseStudy from "./pages/OncologySurvivalCaseStudy";
import ClinicPatientRetention from "./pages/ClinicPatientRetention";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import Contact from "./pages/Contact";
import Privacy from "./pages/Privacy";
import Admin from "./pages/Admin";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <Header />
          <div className="pt-40 md:pt-44">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/services" element={<Services />} />
              <Route path="/services/ivf-fertility-analytics" element={<IVFFertilityAnalytics />} />
              <Route path="/services/healthcare-performance-analytics" element={<HealthcarePerformanceAnalytics />} />
              <Route path="/services/clinical-quality-compliance-analytics" element={<ClinicalQualityComplianceAnalytics />} />
              <Route path="/services/predictive-analytics-decision-intelligence" element={<PredictiveAnalyticsDecisionIntelligence />} />
              <Route path="/services/research-biostatistics" element={<ResearchBiostatistics />} />
              <Route path="/case-studies" element={<CaseStudies />} />
              <Route path="/case-studies/ivf-performance-dashboard" element={<IVFDashboardCaseStudy />} />
              <Route path="/case-studies/patient-satisfaction-analysis" element={<PatientSatisfactionCaseStudy />} />
              <Route path="/case-studies/ivf-cancellation-risk" element={<IVFCancellationRiskCaseStudy />} />
              <Route path="/case-studies/oncology-survival-analysis" element={<OncologySurvivalCaseStudy />} />
              <Route path="/case-studies/clinic-patient-retention" element={<ClinicPatientRetention />} />
              <Route path="/case-studies/:slug" element={<CaseStudyDetail />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:slug" element={<BlogPost />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/admin" element={<Admin />} />
            </Routes>
          </div>
          <Footer />
          <Toaster />
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
